<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { isWorkspaceV2Path } from 'dashboard/helper/workspaceV2';
import { worldById } from 'dashboard/routes/dashboard/hub/hubWorldLookup';

const props = defineProps({
  contact: {
    type: Object,
    default: null,
  },
  conversationId: {
    type: Number,
    required: true,
  },
  createdAgo: {
    type: String,
    default: '',
  },
  createdAt: {
    type: String,
    default: '',
  },
});

const route = useRoute();
const conversationHref = computed(() => {
  const prefix = isWorkspaceV2Path(route.path) ? '/v2' : '';
  const fromWorld =
    typeof route.query?.from_world === 'string'
      ? worldById(route.query.from_world)?.id
      : null;
  const query = fromWorld ? `?from_world=${encodeURIComponent(fromWorld)}` : '';

  return `/app/accounts/${route.params.accountId}${prefix}/conversations/${props.conversationId}${query}`;
});
</script>

<template>
  <div class="flex items-center gap-2">
    <Avatar
      :src="contact?.thumbnail || ''"
      :name="contact?.name || ''"
      :size="32"
      rounded-full
    />
    <div class="flex flex-col gap-0.5">
      <span class="text-sm text-n-slate-12 font-medium capitalize">
        {{ contact?.name || '—' }}
      </span>
      <div
        class="flex items-center gap-1 text-xs text-n-slate-10 whitespace-nowrap"
      >
        <a
          :href="conversationHref"
          class="flex items-center text-xs gap-0.5 hover:text-n-brand hover:underline"
          target="_blank"
          rel="noopener noreferrer nofollow"
        >
          <span>#{{ conversationId }}</span>
        </a>
        <span>·</span>
        <span :title="createdAt">{{ createdAgo }}</span>
      </div>
    </div>
  </div>
</template>
